import React, { Fragment } from "react";
import './paragraph.scss';

const Paragraph = () => {

return (
    <Fragment>
        <div className="max-width-1440 paragraph">
            <h4>Códigos de descuento</h4>
            <p>¿Sos socio del Club La Voz? Obtené tu código y disfrutá beneficios exclusivos en tus marcas favoritas</p>
        </div>
    </Fragment>
)
}

export default Paragraph;